export default __webpack_public_path__ + "static/media/kgv-03.90181cf5.jpg";